import { render, staticRenderFns } from "./OwnerDashboardLayout.vue?vue&type=template&id=ee88fd66&"
import script from "./OwnerDashboardLayout.vue?vue&type=script&lang=js&"
export * from "./OwnerDashboardLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports